import React from 'react'
import {
  addFavorite,
  removeFavorite,
  selectFavorites
} from '@SonarCX/slices/favorites'
import { useAppDispatch, useAppSelector } from '../redux'

const useFavorites = () => {
  const dispatch = useAppDispatch()
  const { favorites, loaded } = useAppSelector(selectFavorites)
  const favoriteTasks = favorites.filter(f => f.type === 'task')
  const favoriteUsers = favorites.filter(f => f.type === 'user')
  const favoriteArticles = favorites.filter(f => f.type === 'article')
  const favoriteSessions = favorites.filter(f => f.type === 'session')
  const favoritePeerChats = favorites.filter(f => f.type === 'peer_chat')

  const handleFavoriteClick = React.useCallback(
    async (
      userId: string,
      isFavorite: boolean,
      idToSave: string,
      type: APIFavorite['type']
    ) => {
      if (isFavorite) {
        await dispatch(removeFavorite(userId, idToSave))
        return
      }
      await dispatch(addFavorite(userId, { item_id: idToSave, type }))
    },
    [dispatch]
  )

  return {
    loaded,
    allFavorites: favorites,
    favoriteTasks,
    favoriteUsers,
    favoriteArticles,
    favoriteSessions,
    favoritePeerChats,
    handleFavoriteClick
  }
}
export default useFavorites
